import http, { expandURI } from '@/utils/ajax'
import { TOTALIP_INIT_LOADING, TOTALIP_INIT_SUCCESS, TOTALIP_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDateTime2 } from '@/utils/date'

const state = {
  totalInforcedProposals: {
    init: 0,
    menu: {},
    noQuote: null,
    lastUpdated: null,
    scope: null,
    info: null,
    appIds: []
  }
}

const getters = {

}

const actions = {
  async initTotalInforcedProposals({ commit, state }, data) {
    commit(TOTALIP_INIT_LOADING)
    const apiUrl = state.permitWidgets.totalInforcedProposals
    if (apiUrl) {
      try {
        let params = {
          from: formatDisplayDateTime2(data.from),
          to: formatDisplayDateTime2(data.to)
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)
        Object.assign(data, {
          menu: menu,
          noQuote: result.data.noQuote,
          info: result.data.info,
          appIds: result.data.appIds
        })
        commit(TOTALIP_INIT_SUCCESS, data)
      } catch (error) {
        commit(TOTALIP_INIT_FAIL)
      }
    } else {
      commit(TOTALIP_INIT_FAIL)
    }
  }
}

const mutations = {
  [TOTALIP_INIT_LOADING](state) {
    state.totalInforcedProposals.init = 0
  },
  [TOTALIP_INIT_SUCCESS](state, data) {
    const { totalInforcedProposals } = state
    totalInforcedProposals.menu = data.menu
    totalInforcedProposals.init = 1
    totalInforcedProposals.lastUpdated = new Date()
    totalInforcedProposals.scope = data.scope
    totalInforcedProposals.noQuote = data.noQuote
    totalInforcedProposals.info = data.info
    totalInforcedProposals.appIds = data.appIds
  },
  [TOTALIP_INIT_FAIL](state) {
    state.totalInforcedProposals.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
